import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { Container, Typography, Box } from "@mui/material";

/**
 * Layout for org-level Attendees: list (index) and detail (:attendeeId).
 */
export default function Attendees() {
  const { attendeeId } = useParams();

  return (
    <Container>
      <Box sx={{ py: 2 }}>
        {!attendeeId && (
          <Typography variant="h2">Attendees</Typography>
        )}
        <Outlet />
      </Box>
    </Container>
  );
}
